import { z } from "zod";

const organisationContactDetailsSchema = z.object({
  website: z
    .string()
    .refine((val) => !val || z.string().url().safeParse(val).success, {
      message: "Invalid URL format",
    })
    .optional(),
  phoneNumber: z.string().optional(),
});
type OrganisationContactDetailsFormData = z.infer<
  typeof organisationContactDetailsSchema
>;

export { organisationContactDetailsSchema };
export type { OrganisationContactDetailsFormData };
